import { PrismicLink, PrismicSharpImage, TextFromRichText } from './PrismicTypes';

export const GENERIC_FEATURED_CONTENT = 'PrismicGenericTemplateDataBodyFeaturedContent';

export interface FeaturedContentItem {
  content_title: TextFromRichText;
  content_description: TextFromRichText;
  content_link: PrismicLink;
  content_image?: PrismicSharpImage;
}

export interface FeaturedContentPrimary {
  featured_title: TextFromRichText;
}

export interface GenericFeaturedContentProps {
  __typename: typeof GENERIC_FEATURED_CONTENT;
  items: FeaturedContentItem[];
  primary: FeaturedContentPrimary;
}
